const Navbar = ({data, logged = false}) => {
    const [links, setLinks] = React.useState(data);
    const [navbarColor, setNavbarColor] = React.useState('');
    const [isFormVisible, setIsFormVisible] = React.useState(false);
    const [isSearchVisible, setIsSearchVisible] = React.useState(false); // Stato per la visibilità del contenitore di ricerca
    const [searchTerm, setSearchTerm] = React.useState(''); // Stato per il termine di ricerca
    const [menuOpen, setMenuOpen] = React.useState(false);

    const DEADLINE = new Date("2025-09-21T23:59:59");
    const tempoScaduto = DEADLINE - new Date;

    React.useEffect(() => {
        setLinks(data);
    }, [data]);

    // useEffect per gestire lo scroll
    React.useEffect(() => {
        const handleScroll = () => {
            const navbars = document.querySelectorAll('.navbar');
            navbars.forEach(navbar => {
                if (window.scrollY > 50) {
                    navbar.style.background = 'rgba(0, 0, 0, 0.2)';
                } else {
                    navbar.style.background = 'transparent';
                }
            });
        };

        // Aggiungo il listener all'evento scroll
        document.addEventListener('scroll', handleScroll);

        // Cleanup: rimuovo il listener quando il componente si smonta
        return () => {
            document.removeEventListener('scroll', handleScroll);
        };
    }, []); // L'array vuoto significa che l'effetto viene eseguito solo una volta al montaggio

    // Funzione per gestire il click sul tasto "Cerca"

    React.useEffect(() => {
        if (isSearchVisible) {
            const input = document.getElementById("search-bar");
            if (input) input.focus();
        }
    }, [isSearchVisible]);
    const handleSearchToggle = () => {
        setIsSearchVisible(prevState => {
            const nextState = !prevState;
            if (nextState) {
            setSearchTerm(''); // reset solo quando si apre
            }
            return nextState;
        });
    };
    const inputAutofocus = () => {
        document.getElementById("search-bar").focus();
    }

    // Funzione per gestire il cambiamento del termine di ricerca
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    // Funzione per gestire la submit della ricerca
    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Evita comportamenti predefiniti indesiderati


        if (searchTerm.trim() !== '') {
            const url = `${links?.cerca?.url}?termine_ricerca=${encodeURIComponent(searchTerm)}`;
            window.location.href = url;
        }
    };

    const toggleMenu = () => setMenuOpen(!menuOpen);
    React.useEffect(() => {
        if (menuOpen) {
            document.body.style.overflow = "hidden";
      
        }
        else {
            document.body.style.overflow = "overlay";
        }
    }, [menuOpen]);

    React.useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 900) {
                setMenuOpen(false);
                document.body.style.overflow = "overlay";
            }
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const MenuElements = ({ links }) => (
        <ul>
            {logged ? (
                <>
                    <li>
                        {/*{links?.consigli?.url}*/}
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLSdv6OLtI5Be1CELKhuZ-YM84zuN5rJVtjlLlY9dbMP06UGWfw/viewform?usp=header" title="Aiutaci a migliorare">
                            Aiutaci a migliorare
                        </a>
                    </li>
                    <li>
                        <a
                            href={links?.cerca?.url}
                            title="Cerca"
                            className={links?.cerca?.url === '#' ? 'disabled' : ''}
                            aria-current={links?.cerca?.isPage ? "page" : undefined}
                            onClick={(e) => {
                                e.preventDefault(); // Evita il comportamento di default del link
                                handleSearchToggle(); // Alterna la visibilità del contenitore di ricerca
                            }}
                        >
                            Cerca
                        </a>
                    </li>
                    <li>
                        <a href={links?.argomenti?.url} title="Catalogo" className={links?.argomenti?.url === '#' ? 'disabled' : ''} aria-current={links?.argomenti?.isPage ? "page" : undefined}>
                            Catalogo
                        </a>
                    </li>
                    <li>
                        <a href={links?.salvati?.url} title="Salvati" className={links?.salvati?.url === '#' ? 'disabled' : ''} aria-current={links?.salvati?.isPage ? "page" : undefined}>
                            Salvati
                        </a>
                    </li>
                    <li>
                        <a href={links?.profilo?.url} title="Profilo" className={links?.profilo?.url === '#' ? 'disabled' : ''} aria-current={links?.profilo?.isPage ? "page" : undefined}>
                            Profilo
                        </a>
                    </li>
                </>
            ) :  (
                <>
                <li>
                    <a href={links?.chisiamo?.url} title="Chi siamo">
                        Chi siamo
                    </a>
                </li>
                <li>
                    <a href={links?.autori?.url} title="I nostri autori">
                        I nostri autori
                    </a>
                </li>
                <li>
                    <a href={links?.argomenti?.url} title="Catalogo">
                        Catalogo
                    </a>
                </li>
                {(tempoScaduto <= 0) &&
                    <li>
                        <a href={links?.login?.url} title="Accedi" className={links?.login?.url === '#' ? 'disabled' : ''}>
                            Accedi
                        </a>
                    </li>
                }
                <li className="c_mt-3 c_900-mt-0">
                    {/*href={links?.registra?.url}*/}
                    <a href={links?.registra?.url} onClick={() => {setMenuOpen(false)} } className="c_primary-button c_iscriviti c_w-fit" title="Iscriviti">
                        Iscriviti
                    </a>
                </li>
                </>
            )}
        </ul>
    );

    return (
        <>
            <div className="c_d-flex c_flex-col c_nav-sticky">
                <nav className={"c_navbar " + (menuOpen ? "c_bg-primary-grey" : "")}>
                    <div className="c_items-container c_px-5 c_gap-2">
                        <a href={logged ? data?.argomenti?.url : data?.info?.url} title="Homepage" className="c_d-flex c_max-w-14" aria-label="Homepage">
                            <h1><img src="/public/src/img/logo/LOGO_white.svg" className="c_logo" alt="Logo" /></h1>
                        </a>
                        <button type="button" className="c_900-d-none c_menu" onClick={toggleMenu} title={menuOpen ? "Chiudi" : "Menu"}>
                            {menuOpen ? 
                            <img src="/public/src/img/icon/white/close/times.svg" />
                            :
                            <img src="/public/src/img/icon/white/menu/hamburger.svg" />
                            }
                            
                        </button>
                        <div className="c_d-none c_900-d-flex c_w-100 c_justify-content-end">
                            <MenuElements links={links} />
                        </div>
                    </div>

                </nav>
                {menuOpen && 
                    <div className="c_900-d-none c_menuelements c_p-5">
                        <MenuElements links={links} />
                    </div>
                }
            </div>
            {isSearchVisible &&
            <div className="c_modal-box">
                <button type="button" className="c_menu c_absolute c_t-5 c_r-5 c_d-flex" onClick={handleSearchToggle} title="Chiudi">
                    <img src="/public/src/img/icon/white/close/times.svg" />
                </button>
                <form className="c_form-search" onSubmit={handleSearchSubmit} onClick={inputAutofocus}>
                    <input
                        type="text"
                        placeholder="Cerca..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        id="search-bar"
                        autoComplete="off"
                    />
                    <button type="submit" title="Cerca">
                        <img src="/public/src/img/icon/white/search/search-bold.svg" />
                    </button>
                </form>
            </div>
            }
        </>
    );
};
